// src/pages/Home.jsx
import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./Home.css";
import NewsletterPopup from "../components/NewsletterPopup";

const LANGUAGE_STORAGE_KEY = "zedro_academy_language";

const HOME_COPY = {
  es: {
    marquee: [
      ["Todo con orden.", "1 Co 14:40"],
      ["Con sabiduría se edifica la casa.", "Pr 24:3"],
      ["Renueva tu entendimiento.", "Ro 12:2"],
      ["Sé hacedor, no solo oidor.", "Stg 1:22"],
      ["Encomienda al Señor tus obras.", "Pr 16:3"],
      ["Hazlo de corazón.", "Col 3:23"],
      ["Cuenta tus días con sabiduría.", "Sal 90:12"],
      ["La buena tierra da fruto.", "Lc 8:15"],
      ["El prudente edifica sobre roca.", "Mt 7:24"],
      ["Camina en verdad.", "3 Jn 1:4"],
    ],
    heroTitle: [
      "Ordena tu interior.",
      "Fortalece tus decisiones.",
      "Construye con propósito.",
    ],
    heroSubtitle:
      "Una membresía de formación práctica para ordenar tu interior, fortalecer tus decisiones y llevar principios eternos a tu vida diaria con estructura, bitácora y oración.",
    primaryCta: "Ver membresía",
    secondaryCta: "Ver metodología",
    heroMeta: "Formación práctica • estructura clara • aplicación diaria • crecimiento con raíz",
    heroNote: "Una vida bien construida no es casualidad.",
    tensionBig: ["Mucho potencial.", "Demasiado ruido.", "Falta de estructura."],
    tensionQuote: ["No necesitas más presión.", "Necesitas una forma clara de avanzar."],
    tensionMicro:
      "ZEDRO Academy convierte principios eternos en práctica diaria para ayudarte a ordenar tu interior, enfocar tus decisiones y construir una vida con sentido.",
    introTitle: "Una formación para ordenar la vida desde adentro.",
    introLead:
      "ZEDRO Academy no nace para llenar tu agenda de más contenido. Nace para ayudarte a convertir principios eternos en práctica diaria: ordenar lo que piensas, fortalecer cómo decides y construir una vida coherente con lo que dices creer.",
    introLeadCompact:
      "Aquí no se persigue una versión idealizada de éxito. Se trabaja una vida con raíz, carácter, responsabilidad y fruto real.",
    pillars: [
      {
        title: "Identidad",
        text: "Reconocer desde dónde vives antes de decidir qué construir.",
      },
      {
        title: "Orden",
        text: "Alinear pensamientos, prioridades y hábitos a principios claros.",
      },
      {
        title: "Acción",
        text: "Dar pasos concretos con enfoque, constancia y responsabilidad.",
      },
      {
        title: "Multiplicación",
        text: "Construir fruto que bendice, sirve y trasciende lo personal.",
      },
    ],
    productEyebrow: "Dentro de la membresía",
    productTitle: "Un ecosistema práctico para formar, aplicar y sostener.",
    productSubtitle:
      "ZEDRO Academy reúne formación guiada, bitácora personal y espacios de conexión para que el proceso no se quede en inspiración, sino que tome forma en la vida diaria.",
    productHeroLabel: "Vista del ecosistema",
    productHeroTitle: "Una plataforma creada para acompañar procesos reales.",
    productHeroText:
      "Cada parte de ZEDRO Academy está pensada para reducir ruido, ordenar el avance y ayudarte a volver a lo esencial con claridad.",
    productCards: [
      {
        img: "/assets/images/home/home-zedro-formacion-oracion-escenas.png",
        alt: "Personas usando ZEDRO Academy en diferentes momentos de formación y oración",
        label: "Formación guiada",
        title: "Cimientos ZEDRO",
        text: "Sistemas prácticos para trabajar áreas concretas de la vida con enseñanza, reflexión, micro-misiones y aplicación diaria.",
      },
      {
        img: "/assets/images/home/home-bitacora-zedro-proceso.png",
        alt: "Bitácora ZEDRO como biblioteca personal del proceso",
        label: "Proceso personal",
        title: "Bitácora ZEDRO",
        text: "Un lugar para guardar respuestas, decisiones y evidencias, para que el avance no se pierda en el ruido del día.",
      },
      {
        img: "/assets/images/home/home-ecosistema-zedro-mobile.png",
        alt: "ZEDRO Academy usado desde el celular para conexión, oración y avance diario",
        label: "Oración ordenada",
        title: "Conexión ZEDRO",
        text: "Un espacio para ordenar cargas, decisiones y oración delante de Dios, llevándolas a pasos concretos y conscientes.",
      },
    ],
    productFooter:
      "ZEDRO Academy seguirá creciendo, pero siempre bajo una misma regla: herramientas reales, contenido con profundidad y aplicación práctica.",
    methodTitle: "Un método para convertir principios en práctica diaria.",
    methodLead:
      "ZEDRO Academy no está diseñado para que acumules más información. Está diseñado para ayudarte a comprender, ordenar, practicar y sostener una forma de vida con raíz, claridad y propósito.",
    methodSteps: [
      {
        num: "01",
        title: "Comprender",
        text: "Recibes dirección clara para mirar tu vida desde principios eternos, no desde presión, ruido o comparación.",
      },
      {
        num: "02",
        title: "Ordenar",
        text: "Cada sistema trabaja un área concreta de tu vida para alinear pensamiento, decisiones, hábitos y prioridades.",
      },
      {
        num: "03",
        title: "Practicar",
        text: "La formación baja a acciones pequeñas: micro-misiones, reflexión, bitácora y aplicación real en tu día.",
      },
      {
        num: "04",
        title: "Sostener",
        text: "No se trata de emoción momentánea, sino de formar criterio, carácter y fruto visible en la vida cotidiana.",
      },
    ],
    methodNote: "No es motivación. Es formación aplicada para una vida bien construida.",
    methodCta: "Ver metodología completa",
    manifestoEyebrow: "Declaración ZEDRO",
    manifestoTitle: "No creemos en fórmulas rápidas. Creemos en formación con raíz.",
    manifestoParagraphs: [
      "ZEDRO Academy nace para acompañar procesos reales: comprender, ordenar, practicar y sostener una vida más coherente con propósito.",
      "No construimos desde presión ni motivación vacía. Trabajamos con verdad aplicada, responsabilidad diaria y una mirada que vuelve al diseño original.",
    ],
    manifestoClosing:
      "Porque una vida bien construida también puede convertirse en fruto, servicio e influencia.",
    principlesTitle: "Principios que sostienen el camino",
    principlesAria: "Ecosistema de principios",
    carouselAria: "Carrusel de principios",
    finalTitle: "Una vida bien construida no es casualidad.",
    finalText:
      "Empieza a formarte con sistemas prácticos para ordenar tu interior, fortalecer tus decisiones y construir con propósito.",
    productHeroAlt: "Vista visual del ecosistema ZEDRO Academy en computador",
  },
  fr: {
    marquee: [
      ["Que tout se fasse avec ordre.", "1 Co 14:40"],
      ["C’est par la sagesse qu’une maison se bâtit.", "Pr 24:3"],
      ["Renouvelle ton intelligence.", "Rm 12:2"],
      ["Sois une personne qui met en pratique, et non seulement qui écoute.", "Jc 1:22"],
      ["Recommande tes œuvres au Seigneur.", "Pr 16:3"],
      ["Fais-le de tout ton cœur.", "Col 3:23"],
      ["Compte tes jours avec sagesse.", "Ps 90:12"],
      ["La bonne terre porte du fruit.", "Lc 8:15"],
      ["La personne prudente bâtit sur le roc.", "Mt 7:24"],
      ["Marche dans la vérité.", "3 Jn 1:4"],
    ],
    heroTitle: [
      "Mets de l’ordre en toi.",
      "Fortifie tes décisions.",
      "Construis avec intention.",
    ],
    heroSubtitle:
      "Un abonnement de formation pratique pour mettre de l’ordre dans ton monde intérieur, fortifier tes décisions et intégrer des principes éternels à ta vie quotidienne avec structure, journal de bord et prière.",
    primaryCta: "Voir l’abonnement",
    secondaryCta: "Voir la méthodologie",
    heroMeta: "Formation pratique • structure claire • application quotidienne • croissance enracinée",
    heroNote: "Une vie bien construite n’est pas le fruit du hasard.",
    tensionBig: ["Beaucoup de potentiel.", "Trop de bruit.", "Un manque de structure."],
    tensionQuote: ["Tu n’as pas besoin de plus de pression.", "Tu as besoin d’une façon claire d’avancer."],
    tensionMicro:
      "ZEDRO Academy transforme des principes éternels en pratique quotidienne pour t’aider à mettre de l’ordre en toi, orienter tes décisions et construire une vie porteuse de sens.",
    introTitle: "Une formation pour ordonner la vie de l’intérieur.",
    introLead:
      "ZEDRO Academy n’existe pas pour remplir ton agenda avec plus de contenu. Elle existe pour t’aider à transformer des principes éternels en pratique quotidienne : ordonner tes pensées, fortifier ta manière de décider et construire une vie cohérente avec ce que tu dis croire.",
    introLeadCompact:
      "Ici, il ne s’agit pas de poursuivre une version idéalisée de la réussite. Il s’agit de travailler une vie enracinée, avec caractère, responsabilité et fruit réel.",
    pillars: [
      {
        title: "Identité",
        text: "Reconnaître d’où tu vis avant de décider ce que tu veux construire.",
      },
      {
        title: "Ordre",
        text: "Aligner tes pensées, tes priorités et tes habitudes sur des principes clairs.",
      },
      {
        title: "Action",
        text: "Faire des pas concrets avec concentration, constance et responsabilité.",
      },
      {
        title: "Multiplication",
        text: "Construire un fruit qui bénit, sert et dépasse le seul cadre personnel.",
      },
    ],
    productEyebrow: "Dans l’abonnement",
    productTitle: "Un écosystème pratique pour former, appliquer et soutenir.",
    productSubtitle:
      "ZEDRO Academy réunit une formation guidée, un journal personnel et des espaces de connexion afin que le processus ne reste pas au niveau de l’inspiration, mais prenne forme dans la vie quotidienne.",
    productHeroLabel: "Vue de l’écosystème",
    productHeroTitle: "Une plateforme créée pour accompagner des processus réels.",
    productHeroText:
      "Chaque partie de ZEDRO Academy est pensée pour réduire le bruit, ordonner l’avancement et t’aider à revenir à l’essentiel avec clarté.",
    productCards: [
      {
        img: "/assets/images/home/home-zedro-formacion-oracion-escenas.png",
        alt: "Personnes utilisant ZEDRO Academy à différents moments de formation et de prière",
        label: "Formation guidée",
        title: "Fondements ZEDRO",
        text: "Des systèmes pratiques pour travailler des domaines concrets de la vie avec enseignement, réflexion, micro-missions et application quotidienne.",
      },
      {
        img: "/assets/images/home/home-bitacora-zedro-proceso.png",
        alt: "Bitácora ZEDRO comme bibliothèque personnelle du processus",
        label: "Processus personnel",
        title: "Bitácora ZEDRO",
        text: "Un lieu pour conserver réponses, décisions et évidences afin que l’avancement ne se perde pas dans le bruit du quotidien.",
      },
      {
        img: "/assets/images/home/home-ecosistema-zedro-mobile.png",
        alt: "ZEDRO Academy utilisée depuis un téléphone pour la connexion, la prière et l’avancement quotidien",
        label: "Prière ordonnée",
        title: "Connexion ZEDRO",
        text: "Un espace pour ordonner les charges, les décisions et la prière devant Dieu, en les reliant à des pas concrets et conscients.",
      },
    ],
    productFooter:
      "ZEDRO Academy continuera de grandir, toujours avec la même règle : des outils réels, un contenu profond et une application pratique.",
    methodTitle: "Une méthode pour transformer des principes en pratique quotidienne.",
    methodLead:
      "ZEDRO Academy n’est pas conçue pour accumuler plus d’information. Elle est conçue pour t’aider à comprendre, ordonner, pratiquer et soutenir une manière de vivre avec racine, clarté et intention.",
    methodSteps: [
      {
        num: "01",
        title: "Comprendre",
        text: "Tu reçois une direction claire pour regarder ta vie à partir de principes éternels, et non à partir de la pression, du bruit ou de la comparaison.",
      },
      {
        num: "02",
        title: "Ordonner",
        text: "Chaque système travaille un domaine concret de ta vie pour aligner pensées, décisions, habitudes et priorités.",
      },
      {
        num: "03",
        title: "Pratiquer",
        text: "La formation descend vers de petites actions : micro-missions, réflexion, journal de bord et application réelle dans ta journée.",
      },
      {
        num: "04",
        title: "Soutenir",
        text: "Il ne s’agit pas d’une émotion passagère, mais de former du discernement, du caractère et un fruit visible dans la vie quotidienne.",
      },
    ],
    methodNote: "Ce n’est pas de la motivation. C’est une formation appliquée pour une vie bien construite.",
    methodCta: "Voir la méthodologie complète",
    manifestoEyebrow: "Déclaration ZEDRO",
    manifestoTitle: "Nous ne croyons pas aux formules rapides. Nous croyons à une formation enracinée.",
    manifestoParagraphs: [
      "ZEDRO Academy naît pour accompagner des processus réels : comprendre, ordonner, pratiquer et soutenir une vie plus cohérente avec l’intention.",
      "Nous ne construisons pas à partir de la pression ni d’une motivation vide. Nous travaillons avec une vérité appliquée, une responsabilité quotidienne et un regard qui revient au dessein originel.",
    ],
    manifestoClosing:
      "Parce qu’une vie bien construite peut aussi devenir fruit, service et influence.",
    principlesTitle: "Des principes qui soutiennent le chemin",
    principlesAria: "Écosystème de principes",
    carouselAria: "Carrousel de principes",
    finalTitle: "Une vie bien construite n’est pas le fruit du hasard.",
    finalText:
      "Commence à te former avec des systèmes pratiques pour mettre de l’ordre en toi, fortifier tes décisions et construire avec intention.",
    productHeroAlt: "Vue visuelle de l’écosystème ZEDRO Academy sur ordinateur",
  },
};

function resolveInitialLanguage() {
  if (typeof window === "undefined") return "es";

  const savedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (["es", "fr"].includes(savedLanguage)) return savedLanguage;

  const params = new URLSearchParams(window.location.search);
  const queryLang = params.get("lang");
  if (queryLang && queryLang.toLowerCase().startsWith("fr")) return "fr";
  if (queryLang && queryLang.toLowerCase().startsWith("es")) return "es";

  return "es";
}

export default function Home() {
  const [language, setLanguage] = React.useState(resolveInitialLanguage);

  React.useEffect(() => {
    if (typeof window === "undefined") return;

    function syncLanguage(nextLanguage) {
      if (["es", "fr"].includes(nextLanguage)) {
        setLanguage(nextLanguage);
      } else {
        setLanguage("es");
      }
    }

    function handleLanguageEvent(event) {
      syncLanguage(event?.detail?.language);
    }

    function handleStorage(event) {
      if (event.key === LANGUAGE_STORAGE_KEY) {
        syncLanguage(event.newValue);
      }
    }

    syncLanguage(window.localStorage.getItem(LANGUAGE_STORAGE_KEY));
    window.addEventListener("zedro:languagechange", handleLanguageEvent);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("zedro:languagechange", handleLanguageEvent);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  const copy = HOME_COPY[language] || HOME_COPY.es;

  const marqueeItems = copy.marquee.map(([text, verse]) => (
    <>
      {text} <span className="verse-ref">{verse}</span>
    </>
  ));

  const marqueeLoop = [...marqueeItems, ...marqueeItems, ...marqueeItems];

  const motionScopeRef = useRef(null);

  useEffect(() => {
    document.documentElement.lang = language === "fr" ? "fr-CA" : "es";
  }, [language]);

  useEffect(() => {
    const root = motionScopeRef.current;
    if (!root) return;

    const els = root.querySelectorAll(".fade-up");
    if (!els.length) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("is-visible");
          else e.target.classList.remove("is-visible");
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -6% 0px" }
    );

    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  const [openPopup, setOpenPopup] = React.useState(false);

  React.useEffect(() => {
    // Popup desactivado durante pre-lanzamiento.
    // Se activará cuando la estrategia de captación esté definida.
    setOpenPopup(false);
  }, []);

  return (
    <div className="home-premium" ref={motionScopeRef}>
      {/* =========================
          HERO
      ========================== */}
      <section className="hp-hero">
        <div className="hp-heroMedia">
          <div
            className="hp-heroPoster"
            style={{ backgroundImage: "url(/assets/images/zedro-hero-poster.jpg)" }}
          />
          <div className="hp-heroOverlay" />
        </div>

        <div className="hp-heroInner">
          <div className="fade-up">
            <h1 className="hp-heroTitle hp-heroTitleStructured">
              {copy.heroTitle.map((line) => (
                <span key={line}>{line}</span>
              ))}
            </h1>

            <p className="hp-heroSubtitle">{copy.heroSubtitle}</p>

            <div className="hp-heroCtas">
              <Link className="hp-ctaPrimary" to="/store">
                {copy.primaryCta}
              </Link>

              <Link className="hp-ctaSecondary" to="/metodologia">
                {copy.secondaryCta}
              </Link>
            </div>

            <div className="hp-heroMeta">{copy.heroMeta}</div>

            <div className="hp-heroNote">{copy.heroNote}</div>
          </div>
        </div>
      </section>

      {/* =========================
          TENSIÓN
      ========================== */}
      <section className="hp-section hp-tension hp-section--alt">
        <div className="hp-container">
          <div className="hp-tensionGrid">
            <div className="hp-tensionBig fade-up">
              {copy.tensionBig.map((line) => (
                <div key={line}>{line}</div>
              ))}
            </div>

            <div className="hp-tensionSmall fade-up">
              <div className="hp-tensionQuote">
                {copy.tensionQuote.map((line) => (
                  <div key={line}>{line}</div>
                ))}
              </div>

              <div className="hp-tensionMicro">{copy.tensionMicro}</div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================
          ZEDRO Academy ES…
      ========================== */}
      <section className="hp-section hp-intro">
        <div className="hp-container">
          <div className="hp-introGrid">
            <div className="hp-introCopy fade-up">
              <h2 className="hp-h2">{copy.introTitle}</h2>

              <p className="hp-lead">{copy.introLead}</p>

              <p className="hp-lead hp-lead--compact">{copy.introLeadCompact}</p>
            </div>

            <div className="hp-pillars hp-pillars--stacked fade-up">
              {/* Identidad */}
              <div className="hp-card">
                <div className="hp-cardIcon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 12a4.2 4.2 0 1 0-4.2-4.2A4.2 4.2 0 0 0 12 12Z"
                      stroke="currentColor"
                      strokeWidth="1.6"
                    />
                    <path
                      d="M4.5 20c1.9-4.2 13.1-4.2 15 0"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>

                <div>
                  <div className="hp-cardTitle">{copy.pillars[0].title}</div>
                  <div className="hp-cardText">{copy.pillars[0].text}</div>
                </div>
              </div>

              {/* Orden */}
              <div className="hp-card">
                <div className="hp-cardIcon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M4.5 4.5h6.8v6.8H4.5zM12.7 4.5h6.8v6.8h-6.8zM4.5 12.7h6.8v6.8H4.5zM12.7 12.7h6.8v6.8h-6.8z"
                      stroke="currentColor"
                      strokeWidth="1.6"
                    />
                  </svg>
                </div>

                <div>
                  <div className="hp-cardTitle">{copy.pillars[1].title}</div>
                  <div className="hp-cardText">{copy.pillars[1].text}</div>
                </div>
              </div>

              {/* Acción */}
              <div className="hp-card">
                <div className="hp-cardIcon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M13 2 4.8 13.2H12L11 22l8.2-11.2H12.1Z"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <div>
                  <div className="hp-cardTitle">{copy.pillars[2].title}</div>
                  <div className="hp-cardText">{copy.pillars[2].text}</div>
                </div>
              </div>

              {/* Multiplicación */}
              <div className="hp-card">
                <div className="hp-cardIcon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 3l1.2 4.2L17.4 8.4l-4.2 1.2L12 13.8l-1.2-4.2L6.6 8.4l4.2-1.2L12 3Z"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18.2 13.2l.7 2.5 2.5.7-2.5.7-.7 2.5-.7-2.5-2.5-.7 2.5-.7.7-2.5Z"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinejoin="round"
                      opacity=".9"
                    />
                  </svg>
                </div>

                <div>
                  <div className="hp-cardTitle">{copy.pillars[3].title}</div>
                  <div className="hp-cardText">{copy.pillars[3].text}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================
          PRUEBA VISUAL DEL PRODUCTO
      ========================== */}
      <section className="hp-section hp-productShowcase">
        <div className="hp-container">
          <div className="hp-productHeader fade-up">
            <div className="hp-eyebrow">{copy.productEyebrow}</div>

            <h2 className="hp-h2">{copy.productTitle}</h2>

            <p className="hp-subtitle">{copy.productSubtitle}</p>
          </div>

          <div className="hp-productHero fade-up">
            <div className="hp-productHeroCopy">
              <span className="hp-productLabel">{copy.productHeroLabel}</span>
              <h3>{copy.productHeroTitle}</h3>
              <p>{copy.productHeroText}</p>
            </div>

            <div className="hp-productHeroMedia">
              <img
                src="/assets/images/home/home-ecosistema-zedro-desktop.png"
                alt={copy.productHeroAlt}
                loading="lazy"
              />
            </div>
          </div>

          <div className="hp-productGrid fade-up">
            {copy.productCards.map((card) => (
              <article className="hp-productCard" key={card.title}>
                <div className="hp-productCardMedia">
                  <img src={card.img} alt={card.alt} loading="lazy" />
                </div>

                <div className="hp-productCardBody">
                  <span className="hp-productLabel">{card.label}</span>
                  <h3>{card.title}</h3>
                  <p>{card.text}</p>
                </div>
              </article>
            ))}
          </div>

          <div className="hp-productFooter fade-up">{copy.productFooter}</div>
        </div>
      </section>

      {/* =========================
          METODOLOGÍA
      ========================== */}
      <section id="metodologia" className="hp-section hp-method hp-section--alt">
        <div className="hp-container fade-up">
          <h2 className="hp-h2">{copy.methodTitle}</h2>

          <p className="hp-lead">{copy.methodLead}</p>

          <div className="hp-steps">
            {copy.methodSteps.map((step) => (
              <div className="hp-step" key={step.num}>
                <div className="hp-stepNum">{step.num}</div>
                <div className="hp-stepBody">
                  <div className="hp-stepTitle">{step.title}</div>
                  <div className="hp-stepText">{step.text}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="hp-methodNote">{copy.methodNote}</div>

          <div className="hp-methodCta">
            <Link className="hp-ctaSecondary" to="/metodologia">
              {copy.methodCta}
            </Link>
          </div>
        </div>
      </section>

      {/* =========================
          DECLARACIÓN ZEDRO
      ========================== */}
      <section className="hp-section hp-manifestoSection">
        <div className="hp-container">
          <div className="hp-manifestoCard fade-up">
            <div className="hp-eyebrow hp-eyebrow--center">{copy.manifestoEyebrow}</div>

            <h2 className="hp-h2 hp-manifestoTitle">{copy.manifestoTitle}</h2>

            <div className="hp-manifestoText hp-manifestoText--center">
              {copy.manifestoParagraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}

              <p className="hp-manifestoClosing">{copy.manifestoClosing}</p>
            </div>
          </div>
        </div>
      </section>

      {/* =========================
          PRINCIPIOS
      ========================== */}
      <section className="hp-section hp-marqueeSection" aria-label={copy.principlesAria}>
        <div className="hp-container">
          <div className="hp-marqueeTitle fade-up">{copy.principlesTitle}</div>
        </div>

        <div className="marquee" aria-label={copy.carouselAria}>
          <div className="marquee__track marquee__track--a">
            {marqueeLoop.map((t, i) => (
              <span className="marquee__item" key={`principle-a-${i}`}>
                {t}
              </span>
            ))}
          </div>

          <div className="marquee__track marquee__track--b" aria-hidden="true">
            {marqueeLoop.map((t, i) => (
              <span className="marquee__item" key={`principle-b-${i}`}>
                {t}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* =========================
          CTA FINAL
      ========================== */}
      <section className="hp-section hp-finalCta">
        <div className="hp-container fade-up">
          <h2 className="hp-h2">{copy.finalTitle}</h2>

          <p className="hp-finalText">{copy.finalText}</p>

          <div className="hp-finalActions">
            <Link className="hp-ctaPrimary" to="/store">
              {copy.primaryCta}
            </Link>

            <Link className="hp-ctaSecondary" to="/metodologia">
              {copy.secondaryCta}
            </Link>
          </div>
        </div>
      </section>

      <NewsletterPopup open={openPopup} onClose={() => setOpenPopup(false)} />
    </div>
  );
}
